var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"paddingTop":"200px"}},[_c('p',{staticClass:"top"},[_vm._v("正在建设中，敬请期待")]),_c('p',{staticClass:"bottom",on:{"click":_vm.goHome}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }